import axios, { getEnv } from "./api";

const SugestoesService = {
  get: async () => {
    try {
      const res = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/sugestoes`);
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default SugestoesService;
